import { BaseError } from '@/util/base-error'
import * as queryString from 'querystring'

export class Context {
  static initialize(): Context {
    return new Context(1)
  }
  static valueOf(s: number): Context {
    return new Context(s)
  }

  private constructor(readonly currentStep: number) {
    if (currentStep < 1) throw new Error('currentStep must be >= 1')
  }

  incrementStep(): Context {
    return new Context(this.currentStep + 1)
  }
}

export function toContextQuery(ctx: Context): string {
  return queryString.stringify({ ...ctx })
}

export class InvalidContextQueryError extends BaseError {}
